<template>
  <div>
    <v-row class="primary-pattern" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'margin']"></v-row>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12" sm="12" md="6" lg="11" class="pt-12 pb-6">
        <v-card class="mb-12" style="margin-top: -40vh;" :elevation="offsetTop > 0 ? 12 : 4">
          <v-card-title class="pt-8"></v-card-title>
          <v-row align="center" justify="center" class="mx-0">
            <v-col cols="12" sm="12" md="6" lg="5">
              <v-img max-width="150vh" src="/imagenes/covid/2.jpeg"></v-img>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="mx-0">
            <v-col cols="12" sm="12" md="6" lg="5">
              <v-carousel cycle hide-delimiter-background show-arrows-on-hover>
                <v-carousel-item
                  @click="dialog = true,imagen=item.src"
                  v-for="(item, i) in imagenes"
                  :key="i"
                  :src="item.src"
                >
                  <v-dialog v-model="dialog" width="40%">
                    <v-card class="mx-auto">
                      <v-img contain :src="imagen"></v-img>
                    </v-card>
                  </v-dialog>
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
          <h1 class="text-center text-uppercase pb-4 pt-10 font-weight-boldmy-10">Vizcaya Tips</h1>
          <h1 class="headline text-uppercase text-center pb-1 font-italic">
            Protocolo al
            <strong>salir</strong> de casa
          </h1>
          <p class="text-center pb-3">Si te urge salir, adopta las siguientes medidas</p>
          <v-row
            :class="[$vuetify.breakpoint.mdAndUp ? 'px-10' : '']"
            justify="center"
            class="mx-0"
            align="center"
          >
            <v-col cols="12" sm="6" md="6" lg="5" v-for="(item, index) in salir" :key="index">
              <v-card height="100%" style="border-radius: 0.8rem;">
                <v-card-title class="d-flex justify-center align-center">
                  <v-avatar size="70" color="color">
                    <v-icon size="35" color="white">{{ item.icon }}</v-icon>
                  </v-avatar>
                </v-card-title>
                <v-card-text class="text-center pt-3">
                  <p class="font-weight-bold text-center mb-0">{{ item.text }}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <h1 class="headline text-uppercase text-center pt-10 pb-1 font-italic">
            Protocolo al
            <strong>entrar</strong> a casa
          </h1>
          <p class="text-center pb-3">Toma en cuenta éstas acciones</p>
          <v-row
            :class="[$vuetify.breakpoint.mdAndUp ? 'px-10' : '']"
            justify="center"
            class="mx-0 pb-5"
            align="center"
          >
            <v-col cols="12" sm="6" md="6" lg="5" v-for="(item, index) in entrar" :key="index">
              <v-card height="100%" style="border-radius: 0.8rem;">
                <v-card-title class="d-flex justify-center align-center">
                  <v-avatar size="70" color="color">
                    <v-icon size="35" color="white">{{ item.icon }}</v-icon>
                  </v-avatar>
                </v-card-title>
                <v-card-text class="text-center pt-3">
                  <p class="font-weight-bold text-center mb-0">{{ item.text }}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
.color {
  background-color: #111f3c !important;
}
.primary-pattern {
  height: 60vh;
  background-image: url("/images/imagenes/portada.jpg");
  background-repeat: repeat;
  background-repeat: no-repeat;
}
.margin {
  margin-top: -15px;
}
</style>
<script>
import { mapState } from "vuex";
export default {
  mounted() {},
  data: () => ({
    publicPath: process.env.BASE_URL,
    imagen: "",
    dialog: false,
    imagenes: [
      {
        src: "/imagenes/covid/1.jpeg"
      },
      {
        src: "/imagenes/covid/3.jpeg"
      },
      {
        src: "/imagenes/covid/4.jpeg"
      },
      {
        src: "/imagenes/covid/7.jpeg"
      }
    ],
    salir: [
      {
        text: "Ponte una blusa o camisa de manga larga",
        icon: "mdi-tshirt-v"
      },
      {
        text: "Recoge tu cabello, no lleves aretes, pulseras o anillos",
        icon: "mdi-face"
      },
      {
        text: "Intenta no usar el transporte público",
        icon: "mdi-bus"
      },
      { text: "No toques tu cara", icon: "mdi-face-profile" },
      {
        text: "Usa panuelos desechables para tocar objetos o superficies ",
        icon: "mdi-check-circle"
      },
      {
        text: "Si toses o estornudas, sigue las recomendaciones",
        icon: "mdi-human-greeting"
      },
      {
        text: "Sí haces compras, no pagues con efectivo",
        icon: "mdi-cash"
      },
      {
        text: "Mantente a distancia de la gente",
        icon: "mdi-transit-transfer"
      },
      {
        text: "Lávate las manos después de tocar cualquier superficie",
        icon: "mdi-responsive"
      }
    ],
    entrar: [
      {
        text: "No tocar nada, al regresar a casa",
        icon: "mdi-block-helper"
      },
      {
        text: "Quitar los zapatos al entrar",
        icon: "mdi-home"
      },
      {
        text: "Sí sacaste a pasear a tus mascotas, desinfecta sus patas",
        icon: "mdi-paw"
      },
      {
        text: "Quítate la ropa exterior y métela en una bolsa para lavarla",
        icon: "mdi-tshirt-v"
      },
      {
        text:
          "Deja bolsas, carteras, llaves a la entrada de tu casa, en una caja",
        icon: "mdi-home"
      },
      {
        text: "Báñate, si no puedes, lávate las zonas expuestas ",
        icon: "mdi-human-handsdown"
      },
      {
        text: "Limpia tu celular con un paño con alcohol",
        icon: "mdi-cellphone"
      },
      {
        text:
          "Limpia las superficies que hayas traído de fuera, antes de guardarlas",
        icon: "mdi-cellphone-link"
      },
      {
        text: "Una vez realizado los pasos anteriores, lávate las manos",
        icon: "mdi-human-handsup"
      }
    ],
    offsetTop: 0
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = window.scrollY;
    }
  },
  computed: {
    ...mapState({
      cities: state => state.cities.cities
    })
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  }
};
</script>
